import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { institutionalApi } from "../api/institutional";
import { complianceApi } from "../api/compliance";
import { userApi } from "../api/institutional/user_api";
import { verifyUserApi } from "../api/institutional/verify_api";
import { onBoardingApi } from "api/institutional/onboarding_api";

import { authSlice } from "./slices/authSlice";
import { webSocketSlice } from "./slices/websocketSlice";
import { modalSlice } from "./slices/modalSlice";
import { globalSlice } from "./slices/globalSlice";
import { presetsSlice } from "./slices/presetsSlice";
import { adminOrdersSlice } from "./slices/adminOrdersSlice";
import { adminOnboardingsSlice } from "./slices/adminOnboardingsSlice";

const persistConfig = {
  key: "presetsv0",
  storage,
};

const rootReducer = combineReducers({
  [institutionalApi.reducerPath]: institutionalApi.reducer,
  [complianceApi.reducerPath]: complianceApi.reducer,
  auth: authSlice.reducer,
  modal: modalSlice.reducer,
  webSocket: webSocketSlice.reducer,
  global: globalSlice.reducer,
  presets: persistReducer(persistConfig, presetsSlice.reducer),
  adminOrders: adminOrdersSlice.reducer,
  adminOnboardings: adminOnboardingsSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: {
        extraArgument: {},
      },
    }).concat([
      institutionalApi.middleware,
      complianceApi.middleware,
      userApi.middleware,
      verifyUserApi.middleware,
      onBoardingApi.middleware,
    ]),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
